import { UrlMatchResult, UrlSegment } from '@angular/router';
import { environment } from 'src/environments/environment';

function configuredMiniMenuHostname(): string {
  try {
    return new URL(environment.miniMenuPublicRoot).hostname.toLowerCase();
  } catch {
    return '';
  }
}

export function isMiniMenuHost(hostname = window.location.hostname): boolean {
  const configured = configuredMiniMenuHostname();
  return Boolean(configured) && hostname.toLowerCase() === configured;
}

export function miniMenuDefaultSlug(): string | null {
  return environment.miniMenuDefaultSlug || null;
}

export function miniMenuHostSlugMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  if (!isMiniMenuHost() || segments.length !== 1) {
    return null;
  }

  return {
    consumed: segments,
    posParams: { slug: segments[0] }
  };
}

export function miniMenuHostRootMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  if (!isMiniMenuHost() || segments.length || !miniMenuDefaultSlug()) {
    return null;
  }

  return { consumed: [] };
}
